import { Component, ReactNode } from 'react';
import { captureException } from '../../utils/sentryUtils';

type ErrorBoundaryProps = {
  children?: ReactNode;
  errorComponent?: ReactNode;
  fingerprint: string;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  componentDidCatch: Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
  >['componentDidCatch'] = (error, errorInfo) => {
    console.error(error);

    captureException(error, {
      fingerprint: [this.props.fingerprint],
      extra: {
        errorInfo,
        componentStack: errorInfo.componentStack,
        error,
      },
    });
  };

  render(): ReactNode {
    const { hasError } = this.state;

    if (!hasError) {
      return this.props.children || null;
    }

    if (this.props.errorComponent) {
      return this.props.errorComponent;
    }

    return null;
  }
}
